import { ArrowLeft } from '@phosphor-icons/react'
import { computed, useSignal } from '@preact/signals-react'
import { useSignals } from '@preact/signals-react/runtime'
import classNames from 'classnames'
import { NO_RESULTS_TEXT_VARIABLE } from '../../const'
import * as $ from '../../signal/searchbox'
import { noResultsTemplate, searchResultsPlaceholder, searchTerm } from '../../signal/searchbox'
import globalStyles from '../../styles/global.module.css'
import { Facets } from '../Facets/Facets'
import { CaretRightIcon } from '../Icons/Icons'
import { SearchResult } from '../SearchResult/SearchResult'
import { Summary } from '../Summary/Summary'
import styles from './SearchResults.module.css'

const noResultsText = computed(() => {
  return noResultsTemplate.value.replace(NO_RESULTS_TEXT_VARIABLE, searchTerm.value ?? '')
})

export function SearchResults() {
  useSignals()
  const results = useSignal($.searchResults).value
  const showShowMoreLink = useSignal($.showShowMoreLink).value
  const focusedResult = useSignal($.focusedResultIndex).value
  const showResultIcon = useSignal($.showResultIcon).value
  const seeAllLink = useSignal($.seeAllLink).value
  const theme = useSignal($.theme).value
  let counterResults = 0

  const secondaryTheme = theme.value === 'secondary'

  function backToSearch() {
    $.isSummaryExpanded.value = false
    $.summaryHistory.value = []
    $.abortAnswer()
  }

  if ($.isSummaryExpanded.value)
    return (
      <div
        className={classNames(styles.searchbox__body, globalStyles.customScrollbar, {
          [styles[`searchbox__body--${theme.value}`]]: theme.value === 'secondary'
        })}
        role="region"
        id="search-results"
        aria-live="polite"
      >
        <button className={styles.searchbox__back__button} onClick={backToSearch} type="button">
          <ArrowLeft size={14} />
          Back to search
        </button>
      </div>
    )

  return (
    <div
      className={`${styles.searchbox__body} ${globalStyles.customScrollbar} ${
        styles[`searchbox__body--${theme.value}`]
      } ${!results.value?.count ? styles.searchbox__bodyEmpty : ''}`}
      role="region"
      id="search-results"
      aria-live="polite"
    >
      {results.value == null && (
        <div className={styles.searchbox__startMessage}>
          <p>{searchResultsPlaceholder.value}</p>
        </div>
      )}
      {results.value?.count === 0 && (
        <div className={styles.searchbox__startMessage}>
          <p>{noResultsText.value}</p>
        </div>
      )}
      {!!results?.value?.count && (
        <>
          <Facets />
          {/* render only on mobile */}
          {secondaryTheme && window.innerWidth < 768 && (
            <div
              className={styles.searchbox__summary__button}
              onClick={() => ($.isSummaryExpanded.value = true)}
              onKeyDown={(e) => e.key === 'Enter' && ($.isSummaryExpanded.value = true)}
              role="button"
              tabIndex={0}
            >
              <Summary className={styles.searchbox__summary} />
            </div>
          )}
          <div className={styles.searchbox__results}>
            {results.value.groupedResults?.map(([sectionName, hits]) => (
              <div key={sectionName}>
                <ul className={styles.searchbox__results__list}>
                  {sectionName && <li className={styles.searchbox_result_section_title}>{sectionName}</li>}
                  {hits.map((hit) => {
                    counterResults += 1
                    return (
                      <SearchResult
                        key={hit.id}
                        hit={hit}
                        isFocused={counterResults === focusedResult.value}
                        showIcon={showResultIcon.value}
                      />
                    )
                  })}
                </ul>
              </div>
            ))}
            {showShowMoreLink.value ? (
              <div className={styles.searchbox__results__more}>
                <a href={seeAllLink.value.url}>
                  {typeof seeAllLink.value.label === 'function' &&
                    seeAllLink.value.label(results?.value?.count.toString(), searchTerm.value || undefined)}
                  {typeof seeAllLink.value.label === 'string' && seeAllLink.value.label}
                  <CaretRightIcon />
                </a>
              </div>
            ) : null}
          </div>
        </>
      )}
    </div>
  )
}
